import React, { memo, useState } from 'react';
import { ExpandContent } from '@anton.bobrov/react-components';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import styles from './index.module.scss.js';

const GroupAccordeon = ({ data }) => {
  const [isActive, setIsActive] = useState(true);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, {
        [styles.open]: isActive
      })
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles.title,
        type: "button",
        onClick: () => {
          setIsActive((prev) => !prev);
        }
      },
      data.title
    ),
    /* @__PURE__ */ React.createElement(
      ExpandContent,
      {
        isActive,
        style: {
          width: "100%"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.list }, data.items.map((link) => /* @__PURE__ */ React.createElement(Link, { className: styles.list__item, to: link.href, key: link.href }, link.title)))
    )
  );
};
var GroupAccordeon$1 = memo(GroupAccordeon);

export { GroupAccordeon$1 as default };
//# sourceMappingURL=index.js.map
